var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequestApproved({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 13.6668C2.98467 13.6668 0 10.6822 0 7.00016C0 3.31816 2.98467 0.333496 6.66667 0.333496C10.3487 0.333496 13.3333 3.31816 13.3333 7.00016C13.3333 10.6822 10.3487 13.6668 6.66667 13.6668ZM6.002 9.66683L10.7153 4.95283L9.77267 4.01016L6.002 7.7815L4.116 5.8955L3.17333 6.83816L6.002 9.66683Z",
    fill: "#08BD50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestApproved);
export default __webpack_public_path__ + "static/media/request-approved.3fa9e433f631db01f5767752489c4b3a.svg";
export { ForwardRef as ReactComponent };